"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
function default_1({ children }) {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: '4px',
            padding: '0 4px',
        } }, { children: children })));
}
exports.default = default_1;
